import React from 'react';

import { Box } from '~/eds/src/components/Box/Box';

import './BlinkingCursor.css';

// TODO: lift this as a formal EDS component and document/test a11y details there.
// https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/log_role
export const BlinkingCursor = () => <Box className="eds_blinking" role="log" />;
